
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/band/[...slug]",
      function () {
        return require("private-next-pages/band/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/band/[...slug]"])
      });
    }
  